import { render, staticRenderFns } from "./area_select.vue?vue&type=template&id=78955cfa&scoped=true"
import script from "./area_select.vue?vue&type=script&lang=js"
export * from "./area_select.vue?vue&type=script&lang=js"
import style0 from "./area_select.vue?vue&type=style&index=0&id=78955cfa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78955cfa",
  null
  
)

export default component.exports